"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonElement = function ButtonElement(_ref) {
  var item = _ref.item;
  var containedStyle = {
    zIndex: 2,
    backgroundColor: item.attributes.background,
    color: item.attributes.color
  };
  var outlinedStyle = {
    zIndex: 2,
    borderColor: item.attributes.background,
    backgroundColor: "transparent",
    color: item.attributes.color
  };
  var styles = {
    outlined: outlinedStyle,
    contained: containedStyle
  };
  console.log("ESTILOS button field: ", item);
  var defaultStyles = styles[item.attributes.variant];
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  console.log("ESTILOS button style: ", style);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      marginTop: 15,
      justifyContent: item.attributes.align
    }
  }, /*#__PURE__*/React.createElement(_core.Button, {
    variant: item.attributes.variant,
    fullWidth: item.attributes.fullWidth,
    style: style
  }, item.attributes.label));
};

var _default = ButtonElement;
exports.default = _default;